import { useTranslation } from "react-i18next";
import { Alert, AlertIcon, Button, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay, Text, Tag, List, ListItem, Box, VStack, Badge } from "@chakra-ui/react"

interface props {
    isModalOpen: boolean;
    isNeedUpdate: boolean;
    onYes: () => void;
    onYesAnd: () => void;
    onNo: () => void;
}

export const UpdateApproverModal = ({ isModalOpen, isNeedUpdate, onYes, onYesAnd, onNo }: props) => {
    const { t, i18n } = useTranslation("translation");
    return (
        <Modal
            closeOnOverlayClick={false}
            isOpen={isModalOpen}
            onClose={onNo}
            size={isNeedUpdate ? "lg" : "md"}>
            <ModalOverlay />
            <ModalContent>
                <ModalHeader className='!font-bold lg'>更新請假流程提示</ModalHeader>
                <ModalCloseButton />

                <ModalBody pb={6}>
                    <Alert status="info" borderRadius="lg" mb={5} className="bg-blue-50/80 border border-blue-200">
                        <AlertIcon color="blue.500" />
                        <Box color="gray.800">
                            {/* <Text fontWeight="bold" color="blue.900" mb={0.5}>
                                簽核關卡規則調整說明
                            </Text> */}
                            <div>
                                變更後的<Text as="span" fontWeight="bold" color="blue.700">「關卡與簽核關卡規則」</Text>將<Text as="span" fontWeight="bold" color="red.600">立即套用</Text>至<b>當學期</b>所有進行中的假單。
                            </div>
                            {
                                isNeedUpdate &&
                                <div>
                                    請選擇下方按鈕決定<Text as="span" fontWeight="bold" color="blue.700">「簽核人員帳號」</Text>的套用方式：
                                </div>
                            }
                        </Box>
                    </Alert>

                    <VStack spacing={4} align="stretch">
                        {/* 取消選項 */}
                        <Box className="flex items-start gap-3 p-4 rounded-xl bg-gray-50 border border-gray-200">
                            <Tag colorScheme="orange" size="lg" variant="solid" className="shrink-0 font-bold">
                                取消
                            </Tag>
                            <Text fontSize="md" color="gray.700" className="mt-0.5">
                                返回設定畫面，不儲存任何設定。
                            </Text>
                        </Box>

                        {/* 儲存選項 */}
                        <Box className="flex items-start gap-3 p-4 rounded-xl bg-blue-50/70 border border-blue-200">
                            <Tag colorScheme="blue" size="lg" variant="solid" className="shrink-0 font-bold">
                                儲存
                            </Tag>
                            <Box className="mt-0.5">
                                {
                                    isNeedUpdate ? <>
                                        <Text fontSize="md" fontWeight="bold" color="blue.800" mb={1.5}>
                                            僅套用至未來新假單
                                        </Text>
                                        <VStack align="start" spacing={1} fontSize="sm" color="gray.700">
                                            <Text>• <Text as="span" fontWeight="semibold">現有假單</Text>：保持原樣，簽核人員不變。</Text>
                                            <Text>• <Text as="span" fontWeight="semibold">未來假單</Text>：套用新的簽核人員帳號。</Text>
                                        </VStack>
                                    </>
                                        :
                                        <Text fontSize="md" fontWeight="bold" color="blue.800" mb={1.5}>
                                            當學期所有簽核中的假單將立即套用
                                        </Text>
                                }

                            </Box>
                        </Box>

                        {/* 儲存並同步選項 */}
                        {isNeedUpdate && (
                            <Box className="flex items-start gap-3 p-4 rounded-xl bg-emerald-50/70 border border-emerald-200">
                                <Tag colorScheme="green" size="lg" variant="solid" className="shrink-0 font-bold">
                                    儲存並同步
                                </Tag>
                                <Box className="mt-0.5">
                                    <Text fontSize="md" fontWeight="bold" color="emerald-900" mb={1.5}>
                                        套用至現有與未來假單
                                    </Text>
                                    <VStack align="start" spacing={1} fontSize="sm" color="gray.700">
                                        <Text>
                                            • <Text as="span" fontWeight="semibold">現有假單</Text>：
                                            <Text as="span" color="red.600" fontWeight="bold">立即更換</Text>為新簽核帳號。
                                        </Text>
                                        <Text>• <Text as="span" fontWeight="semibold">未來假單</Text>：同步套用新設定。</Text>
                                    </VStack>
                                </Box>
                            </Box>
                        )}
                    </VStack>
                </ModalBody>

                <ModalFooter className="gap-4">
                    <Button colorScheme="orange" className="w-full" onClick={onNo}>
                        取消
                    </Button>
                    <Button colorScheme="twitter" className="w-full" onClick={onYes}>
                        儲存
                    </Button>
                    {isNeedUpdate &&
                        <Button colorScheme="green" className="w-full" onClick={onYesAnd}>
                            儲存並同步
                        </Button>
                    }
                </ModalFooter>

            </ModalContent>
        </Modal>
    )
}